























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Icon extends Vue {
  @Prop({ required: true }) name!: string;

  @Prop({ default: '' }) src!: string;

  @Prop({ default: 32 }) size!: number;

  @Prop({ default: false }) border!: boolean;

  @Prop({ default: '' }) fill!: string;

  @Prop() fontSize!: number;

  @Prop({ default: false }) tooltipHidden!: boolean;

  @Prop({ default: false }) isAuthor!: boolean;

  showTooltip = this.tooltipHidden && 'hidden';

  get letter() {
    if (!this.name) {
      return '';
    }

    const [firstname, lastname] = this.name.split(' ');
    return lastname ? `${firstname[0]}${lastname[0]}`.toUpperCase() : `${firstname[0]}`.toUpperCase();
  }
}
